import { RL_APPLICATION_TYPE } from "./phaseConstants";

/**
 * The long names of the Application Type, which say who each type is for.
 * Shown only in the Application Type dropdown (every form that has it) and
 * in the application details (applicant, Admin, L1 / L2 / L3,
 * /view-user-payment). Everywhere else (navbar, lists, payment screens,
 * demand note, certificate) keeps the short name.
 *
 * Display only: the option ids, the option names in cp_field_options and the
 * stored rl_application_type ("Permanent" / "Temporary") are unchanged.
 * Offline Tentative RL has no long name and stays as it is.
 */
export const LONG_APPLICATION_TYPE_LABELS = {
  PERMANENT: "Permanent RL (for sale deed holder's)",
  TENTATIVE: "Tentative RL (for notarised or agreement to Sale or power holder's)",
} as const;

/** By the option's name, as the dropdown lists it. */
const LONG_LABEL_BY_OPTION_NAME: Record<string, string> = {
  "permanent rl": LONG_APPLICATION_TYPE_LABELS.PERMANENT,
  "tentative rl": LONG_APPLICATION_TYPE_LABELS.TENTATIVE,
};

/**
 * The long name for an Application Type option, or the option's own name
 * when it has none.
 */
export function longApplicationTypeOptionName(optionName: string): string {
  return LONG_LABEL_BY_OPTION_NAME[String(optionName ?? "").trim().toLowerCase()] ?? optionName;
}

/**
 * The long name for a stored rl_application_type ("Permanent" /
 * "Temporary"), or null when it has none (Offline Tentative, or nothing).
 */
export function longApplicationTypeLabel(storedType: unknown): string | null {
  const norm = String(storedType ?? "").trim();
  if (norm === RL_APPLICATION_TYPE.PERMANENT) return LONG_APPLICATION_TYPE_LABELS.PERMANENT;
  if (norm === RL_APPLICATION_TYPE.TEMPORARY) return LONG_APPLICATION_TYPE_LABELS.TENTATIVE;
  return null;
}
